import * as React from 'react';
import styles from './FeatureUnavailableBanner.module.scss';

interface FeatureUnavailableBannerProps {
  /** Optional override for the banner copy. */
  message?: string;
}

const DEFAULT_MESSAGE =
  'Get in touch with us to upgrade your account for this feature.';

/**
 * Inline "enabling soon" banner. Unlike `FeatureUnavailable` (a full-page
 * placeholder), this keeps the page content visible and is paired with
 * disabled write actions — used where we still want to show the layout
 * during the rollout (e.g. Delivery Analytics, Analytics Integrations).
 */
export const FeatureUnavailableBanner: React.FC<FeatureUnavailableBannerProps> = ({ message }) => (
  <div className={styles.banner} role="status" data-test="feature-unavailable-banner">
    <span className={styles.badge}>Not enabled</span>
    <span className={styles.message}>{message ?? DEFAULT_MESSAGE}</span>
  </div>
);

export default FeatureUnavailableBanner;
